import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { TreeNode } from 'primeng/api';

@Component({
  selector: 'app-org-chart-quick-action',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './org-chart-quick-action.component.html',
  styleUrl: './org-chart-quick-action.component.scss'
})
export class OrgChartQuickActionComponent {
  @Input() organizationChart: TreeNode[];
  @Input() isPanToolActivating: boolean = false
  @Input() zoomLevel: number = 100;

  @Output() organizationChartChange = new EventEmitter();
  @Output() onPanTool = new EventEmitter();
  @Output() onZoom = new EventEmitter();
  @Output() onFitToScreen = new EventEmitter();

  ngOnChanges(): void {}

  fitToScreen() {
    this.onFitToScreen.emit();
  }

  zoomIn() {
    this.applyZoom(true);
  }

  zoomOut() {
    this.applyZoom(false);
  }

  applyZoom(isZoomIn: boolean) {
    this.onZoom.emit(isZoomIn)
  }

  panTool(event: Event) {
    this.onPanTool.emit()
  }
}
